import { render } from "./KpisControllersSection.vue?vue&type=template&id=78c6db73&scoped=true"
import script from "./KpisControllersSection.vue?vue&type=script&lang=js"
export * from "./KpisControllersSection.vue?vue&type=script&lang=js"

import "./KpisControllersSection.vue?vue&type=style&index=0&id=78c6db73&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78c6db73"]])

export default __exports__